"use client"
import React, { useState, useEffect } from "react"
import { Icon } from "@/components/formatters/MXPIcon"
import { useScreenSize } from "../../utils/hooks/useScreenSize"

export interface SearchButton {
  label?: string
  className?: string
  onSearch?: (value: string) => void
  autoPopulateText?: string
  onChange?: (value: string) => void
}

const WRAP =
  "my-2 mx-0 min-sm:mt-4 min-sm:mb-[18px] text-gray-m10 border border-gray-m10 bg-white rounded-4xl inline-flex relative w-full h-[44px] min-sm:w-[420px] min-sm:h-[60px]"
const SEARCH_ICON =
  "my-[13px] mr-3 ml-[18px] min-sm:my-[21px] min-sm:mr-0 min-sm:ml-[23px]"
const FIELD =
  "text-gray-m7 border-0 mt-[10px] mr-[10px] mb-[10px] ml-0 min-sm:ml-4 text-base min-sm:text-sm font-bold w-[236px] min-sm:w-[260px] focus:outline-none placeholder:text-gray-m7 placeholder:text-sm placeholder:tracking-wide [@supports(-webkit-touch-callout:none)]:!text-base"
const BUTTON =
  "rounded-full bg-yellow-m10 border-0 absolute right-[-2px] flex justify-center items-center p-0 text-gray-m9 transition-[background-color,border-color,box-shadow] duration-150 ease-in-out hover:cursor-pointer hover:bg-yellow-m10 [&_*]:pointer-events-none w-[60px] h-[60px] top-[-8px] min-sm:w-[88px] min-sm:h-[88px] min-sm:top-[-14px]"

export const SearchButton = ({
  label,
  className: _className,
  onSearch = () => {},
  autoPopulateText,
  onChange = () => {},
}: SearchButton) => {
  const { width } = useScreenSize()
  const [searchValue, setSearchValue] = useState("")

  const handleChangeValue = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchValue(e.target.value)
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    onChange && onChange(e.target.value)
  }

  const handleClickSearch = (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    e.preventDefault()
    onSearch(searchValue)
  }

  const handleKeyDown = (ev: React.KeyboardEvent<HTMLInputElement>) => {
    if (ev.key === "Enter") {
      onSearch(searchValue)
    }
  }

  /* eslint-disable react-hooks/set-state-in-effect */
  useEffect(() => {
    if (autoPopulateText) {
      setSearchValue(autoPopulateText)
    }
  }, [autoPopulateText])
  /* eslint-enable react-hooks/set-state-in-effect */

  return (
    <div className={WRAP}>
      <Icon className={SEARCH_ICON} type="t2u-search" size={18} />
      <input
        className={FIELD}
        type="text"
        placeholder={label}
        value={searchValue}
        onKeyDown={handleKeyDown}
        onChange={handleChangeValue}
      />
      <button
        className={BUTTON}
        onClick={handleClickSearch}
        aria-label={label || "Search"}
      >
        <Icon type="t2u-chevron-right" size={width > 600 ? 32 : 20} />
      </button>
    </div>
  )
}
